import { GridPaginationModel, GridSortModel } from '@mui/x-data-grid';
import { useState } from 'react';
import {
  DEFAULT_CONVERSATIONS_SORT,
  DEFAULT_PAGE_SIZE,
} from '../constants/dashboardConstants';
import { toDashboardSort } from '../helpers/dashboardHelper';
import { AgentType } from '../interfaces/Agent';
import { DashboardPaging, ServerPaging } from '../interfaces/DashboardPaging';

/** Page, sort and search of a server paged conversations table. */
export const useConversationsTableState = (agentType: AgentType) => {
  // MUI counts pages from 0, the API from 1
  const [paginationModel, setPaginationModel] = useState<GridPaginationModel>({
    page: 0,
    pageSize: DEFAULT_PAGE_SIZE,
  });
  const [sortModel, setSortModelState] = useState<GridSortModel>(
    DEFAULT_CONVERSATIONS_SORT
  );
  const [search, setSearchState] = useState('');

  // Back to page 1 in the same render, so it is one request and not two
  const backToFirstPage = () =>
    setPaginationModel(current =>
      current.page === 0 ? current : { ...current, page: 0 }
    );
  const setSortModel = (model: GridSortModel) => {
    setSortModelState(model);
    backToFirstPage();
  };
  const setSearch = (value: string) => {
    setSearchState(value);
    backToFirstPage();
  };

  const paging: DashboardPaging = {
    page: paginationModel.page + 1,
    pageSize: paginationModel.pageSize,
    sort: toDashboardSort(sortModel, agentType),
    search,
  };

  const serverPaging = (
    rowCount: number,
    isFetching: boolean
  ): ServerPaging => ({
    rowCount,
    model: paginationModel,
    onModelChange: setPaginationModel,
    isFetching,
    sortModel,
    onSortModelChange: setSortModel,
    search,
    onSearchChange: setSearch,
  });

  return {
    paginationModel,
    setPaginationModel,
    sortModel,
    setSortModel,
    search,
    setSearch,
    backToFirstPage,
    paging,
    serverPaging,
  };
};
